import { useEffect, useState } from 'react';

import { useTheme } from '@savvy/deprecated-shared/hooks/use-theme';

export function useIsMobileMediaQuery() {
  const theme = useTheme();
  const [mounted, setMounted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setMounted(true);
    setIsMobile(window.matchMedia(theme.breakpoints.down('sm')).matches);
  }, [theme]);

  return mounted && isMobile;
}
